<template>
  <div class="product-view">
    <!-- Lors du chargement -->
    <p v-if="loading">Information du produit en cours de chargement...</p>

    <!-- En cas d'erreur -->
    <div v-if="error">
      <p>Une erreur c'est produite lors du chargement des informations du produit.</p>
      <button @click="fetchData" class="btn waves-effect waves-light btn-brico">Recharger</button>
    </div>

    <!-- Une fois chargé (et pas d'erreur) -->
    <div v-if="product">

      <div class="row" v-if="product.active === 0">
        <div class="col s12">
          <div class="card-panel orange darken-1">
            <span class="white-text"><strong>Attention : </strong>produit inactif</span>
          </div>
        </div>
      </div>

      <div class="product">

      <h2>{{product.name}}</h2>
      <p>{{product.ean}}</p>

      <decoupe v-if="product.type === 'cutting'" :product="product"></decoupe>
      <unitaire v-else :product="product"></unitaire>
    </div>
  </div>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";

import Decoupe from "@/components/Product/Decoupe.vue";
import Unitaire from "@/components/Product/Unitaire.vue";

export default {
  name: 'ProductView',
  data() {
    return {
      loading: null,
      error: null,
      product: null,
    };
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    fetchData: function() {
      var vm = this;
      vm.loading = true;
      vm.error = false;

      axios
        .get(
          process.env.VUE_APP_ERP_URL +
            "/products/view/" +
            this.$route.params.id
        )
        .then(function(response) {
          vm.loading = false;
          vm.product = response.data.data;
        })
        .catch(function(error) {
          vm.loading = false;
          vm.error = true;
        });
    }
  },
  components: {
    Decoupe,
    Unitaire
  }
};
</script>

<style scoped>
h2 {
  font-size: 1.3em;
  margin: 0;
}
.product {
  padding: 1em 1em 0 1em;
  background-color: #eeeeee;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  margin-bottom: 1.5em;
}
</style>
